<div class="input-container">
  <div *ngIf="!localStorageUtil.getHouseHoldId('edu-family') && isEduFamily" class="survey-top">
    <div class="household-info">
      <label>
        {{ paragraphUtil.getTranslation('survey_info_message') }}
      </label>
    </div>
  </div>
  <div class="household-info">
    <mat-accordion>
      <mat-expansion-panel class="expansion-panel" [hideToggle]="false" [expanded]="!localStorageUtil.getHouseHoldId('edu-family')">
      <mat-expansion-panel-header class="student-title">
          <mat-panel-title>
          {{ 'Search' | translate }}
          </mat-panel-title>
      </mat-expansion-panel-header>

        <div class="search-tabs">
          <mat-tab-group mat-align-tabs="start">
            <mat-tab *ngIf="!isEduFamily" [label]="'Email' | translate">
              <form [formGroup]="searchByIdForm" (ngSubmit)="searchBySurveyEmail()">
                <div class="search-container">
                  <mat-form-field appearance="legacy">
                    <mat-label>{{ "Email" | translate }}</mat-label>
                    <input formControlName="searchField" [placeholder]="'Email' | translate" required matInput />
                  </mat-form-field>
                  <button type="submit" class="search-button" mat-flat-button color="primary">
                    {{ "Search" | translate }}
                  </button>
                </div>
              </form>
            </mat-tab>
            <mat-tab *ngIf="isEduFamily" [label]="'Household ID or Email' | translate">
              <form [formGroup]="searchByIdForm" (ngSubmit)="searchByIdOrEmail()">
                <div class="search-container">
                  <mat-form-field class="email-input" appearance="legacy">
                    <mat-label>{{ "Household ID or Email" | translate }}</mat-label>
                    <input formControlName="searchField" [placeholder]="'Household ID' | translate" required matInput />
                  </mat-form-field>
                  <button type="submit" class="search-button" mat-flat-button color="primary">
                    {{ "Search" | translate }}
                  </button>
                </div>
              </form>
            </mat-tab>
            <mat-tab *ngIf="isEduFamily" [label]="'Last Name' | translate">
              <form [formGroup]="searchByLastNameForm" (ngSubmit)="searchByLastname()">
                <div class="search-container">
                  <mat-form-field class="form-field select-answer" appearance="standard" [class.hidden]="localStorageUtil.getIsInstitutionURL('edu-family')">
                    <mat-label>{{ "District" | translate }}</mat-label>
                    <mat-select formControlName="institutionId" [attr.disabled]="localStorageUtil.getIsInstitutionURL('edu-family')" required>
                      <mat-option value="">{{"Select an option" | translate}}</mat-option>
                      <mat-option *ngFor="let district of institutionService.allInstutions$.value | filterInstitutionsByType: schoolDistrictType" [value]="district.id">{{ district.description }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="form-field select-answer" appearance="standard">
                    <mat-label>{{ "School" | translate }}</mat-label>
                    <mat-select  formControlName="facilityId" required>
                      <mat-option value="">{{"Select an option" | translate}}</mat-option>
                      <mat-option *ngFor="let school of institutionService.allInstutions$.value  | filterFacilitiesByInst: this.searchByLastNameForm.value.institutionId" [value]="school.id">{{ school.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="legacy">
                    <mat-label>{{ "Student Last Name" | translate }}</mat-label>
                    <input formControlName="lastName" [placeholder]="'Last Name' | translate" required matInput />
                  </mat-form-field>
                  <button type="submit" class="search-button" mat-flat-button color="primary">
                    {{ "Search" | translate }}
                  </button>
                </div>
              </form>
            </mat-tab>
          </mat-tab-group>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div *ngIf="localStorageUtil.getHouseHoldId('edu-family') && isEduFamily" class="household-info">
    <div class="household-id-text">
      <h5 class="color-primary">
        {{ "Household ID" | translate }}:
        <b id="household_id-text">{{ localStorageUtil.getHouseHoldId('edu-family') }}</b>
      </h5>
    </div>
    <div class="disclaimer">
      <label>
        {{ paragraphUtil.getTranslation('privacy_disclaimer') }}
      </label>
    </div>
  </div>
</div>
